import { IconButton } from '@mui/material';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';

export default function SelectEmojiButton({ onClick }) {
  return (
    <IconButton onClick={onClick}>
      <EmojiEmotionsIcon sx={{ color: '#64676A' }} />
    </IconButton>
  );
}
